import React from "react";
import { Collapse,Col, Row } from "antd";
import "../explore-response-details/ExploreResponseDetails.scss";

const { Panel } = Collapse;

const FaqPage = () => {
      return (
            <section style={{ padding: "30px", margin: "0 auto", paddingTop:'8px' }}>
                  <Row>
                   <Col span={24}>
                   <p style={{
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: 'bold',
  float: 'left'
}}> Frequently Asked Questions</p>
            </Col>
            </Row>
                  {/* <Title level={2}>Frequently Asked Questions</Title> */}

                  <Collapse accordion bordered={true} style={{ fontSize: "14px" }}>
                        <Panel header="How do you find patients?" key="1" >
                              <div style={{ padding: '5px' }}>
                                    <div style={{ marginLeft: '35px', marginTop: '10px' }}>
                                          Patients come into the Patient Experience Bank in two main ways:
                                    </div>
                                    <ol style={{ marginLeft: '10px' }}>
                                          <li>
                                                <strong>Through research partners: </strong> ZS collaborates with 30+ vetted global research partners who handle outreach, consent, and survey delivery.
                                          </li>
                                          {/* <br></br> */}
                                          <li>
                                                <strong>Through partnered sites of care: </strong> Patients at these sites receive a QR code linking to the survey. If scanned, patients can review participation details and consent before starting.
                                          </li>
                                    </ol>
                              </div>
                        </Panel>

                        <Panel header="Do participants take the survey in their local language?" key="2">
                        <div style={{ padding: '15px' }}>
                              <div style={{ marginLeft: '35px'}}>
                                    Yes, participants see the survey in the most widely spoken language of their country (e.g., Spanish in Spain). Open-ended responses are translated into English for analysis.
                              </div>
                              </div>
                        </Panel>

                        <Panel header="How are your survey questions designed?" key="3">
                        <div style={{ padding: '5px' }}>
                              <div style={{ marginLeft: '35px', marginTop: '10px' }}>
                                    The survey is crafted at a 4th-grade reading level or lower for clarity. While no validated scales are used, the process includes:
                              </div>
                              <ul style={{ marginLeft: '10px' }}>
                                    <li>Consultation with internal ZS experts</li>
                                    <li>Feedback from patient advocates</li>
                                    <li>Pre-testing for clarity and accessibility</li>
                                    <li>Ongoing iterative refinements based on feedback</li>
                              </ul>
                              </div>
                        </Panel>

                        <Panel header="Do you collect PII?" key="4">
                        <div style={{ padding: '15px' }}>
                              <div style={{ marginLeft: '35px' }}>
                                    No, data files in the Patient Experience Bank contain no Personally Identifiable Information (PII).
                              </div>
                              </div>
                        </Panel>

                        <Panel header="How are patients compensated for participating?" key="5">
                        <div style={{ padding: '15px' }}>
                              <div style={{ marginLeft: '35px' }}>
                                    Participants receive honoraria determined within Fair Market Value by region. For site-recruited patients, ZS RSG handles payments via provided email addresses.
                              </div>
                              </div>
                        </Panel>

                        <Panel header="Can I see an individual’s responses?" key="6">
                        <div style={{ padding: '15px' }}>
                              <div style={{ marginLeft: '35px'}}>
                                    ZS does not typically display individual-level data due to GDPR and other privacy reasons. Contact ZS for deeper insights if necessary.
                              </div>
                              </div>
                        </Panel>

                        <Panel header="Why does the sample size change across questions within a single cohort?" key="7">
                        <div style={{ padding: '5px' }}>
                              <div style={{ marginLeft: '35px' , marginTop: '10px'}}>
                                    Sample size variations can result from:
                              </div>
                              <ul style={{ marginLeft: '10px' }}>
                                    <li>Not all questions are shown to every respondent</li>
                                    <li>Skip logic based on earlier answers</li>
                                    <li>Respondents declining to answer</li>
                                    <li>Exclusion of nonsensical open-text responses</li>
                                    <li>Disease-specific questions with limited applicable respondents</li>
                              </ul>
                              <div style={{ marginLeft: '35px', marginTop: '10px' }}>
                                    Some questions also allow multiple answers, which may affect percentage totals.
                              </div>
                              </div>
                        </Panel>
                  </Collapse>
            </section>
      );
};

export default FaqPage;